import React from 'react';
import { PaymentStatusFilters } from '../../../../app/models/PaymentStatus';

type Props = {
    filter: PaymentStatusFilters;
    setFilter: (filter: PaymentStatusFilters) => void;
};

const PaymentStatusFilter = ({ filter, setFilter }: Props) => {
    const handlerInputFilter = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
        setFilter({
            ...filter,
            [e.target.name]: e.target.value
        });
    };

    return (
        <div className="row">
            <div className="row">
                {/* Despacho */}
                <div className="col-md-auto">
                    <div className="mb-3">
                        <label className="font-size-10 mb-1" htmlFor="dispatch_program_id">
                            Despacho
                        </label>
                        <input
                            title="Despacho"
                            type="number"
                            id="dispatch_program_id"
                            name="dispatch_program_id"
                            className="form-control form-control-sm"
                            value={filter.dispatch_program_id}
                            onChange={handlerInputFilter}
                        />
                    </div>
                </div>

                {/* Sociedad */}
                <div className="col-md-auto">
                    <div className="mb-3">
                        <label className="font-size-10 mb-1" htmlFor="society">
                            Sociedad
                        </label>
                        <input
                            title="Sociedad"
                            type="text"
                            id="society"
                            name="society"
                            className="form-control form-control-sm"
                            value={filter.society || ''}
                            onChange={handlerInputFilter}
                        />
                    </div>
                </div>

                {/* Cliente */}
                <div className="col-md-auto">
                    <div className="mb-3">
                        <label className="font-size-10 mb-1" htmlFor="client">
                            Cliente
                        </label>
                        <input
                            title="Cliente"
                            type="text"
                            id="client"
                            name="client"
                            className="form-control form-control-sm"
                            value={filter.client || ''}
                            onChange={handlerInputFilter}
                        />
                    </div>
                </div>

                {/* Fecha Emisión Desde */}
                <div className="col-md-auto">
                    <div className="mb-3">
                        <label className="font-size-10 mb-1" htmlFor="start_date">
                            Fecha Emisión Desde
                        </label>
                        <input
                            type="date"
                            id="start_date"
                            name="start_date"
                            className="form-control form-control-sm"
                            value={filter.start_date || ''}
                            onChange={handlerInputFilter}
                        />
                    </div>
                </div>

                {/* Fecha Emisión Hasta */}
                <div className="col-md-auto">
                    <div className="mb-3">
                        <label className="font-size-10 mb-1" htmlFor="end_date">
                            Fecha Emisión Hasta
                        </label>
                        <input
                            type="date"
                            id="end_date"
                            name="end_date"
                            className="form-control form-control-sm"
                            value={filter.end_date || ''}
                            onChange={handlerInputFilter}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PaymentStatusFilter;
